import * as types from '@/store/types/pages'
import { setElements, setActivePage } from '@/store/actions'
import PagesWorker from '@/workers/pagesUpate.worker'

const pagesWorker = new PagesWorker()
const savePage = ( id, properties, page_position, accessToken ) => {
  const _properties =
    typeof properties === 'string' ? properties : JSON.stringify( properties )

  pagesWorker.postMessage( {
    pageID: id,
    data: {
      properties: _properties,
      page_position: page_position
    },
    accessToken: accessToken
  } )
}

/**
 * When update a page call the webworker
 * @param {Store} store
 */
const updatePagesMiddleware = store => next => action => {
  if (
    action.type !== types.UPDATE_PAGE &&
    action.type !== types.BATCH_UPDATE_PAGES
  ) {
    return next( action )
  }
  if ( action.type === types.UPDATE_PAGE ) {
    const { pageItem, accessToken } = action.payload
    savePage(
      +pageItem.id,
      pageItem.properties,
      pageItem.page_position,
      accessToken
    )
  }
  if ( action.type === types.BATCH_UPDATE_PAGES ) {
    action.payload.pages.map( page =>
      savePage(
        page.id,
        page.properties,
        page.page_position,
        action.payload.token
      )
    )
  }

  return next( action )
}

/**
 * When the pages are modified
 * @param {Store} store
 */
const setPageMiddleware = store => dispattch => action => {
  if ( action.type !== types.SET_PAGES && action.type !== types.ADD_PAGE ) {
    return dispattch( action )
  }
  const { payload } = action
  if ( Array.isArray( payload ) && !payload.length ) {
    return dispattch( action )
  }
  const item = payload[0] || payload
  item.items = item.items || []
  dispattch( setActivePage( item ) )
  dispattch( setElements( item.items ) )
  return dispattch( action )
}

/**
 * When a page is removed
 * @param {Store} store
 */
const onRemovePageMiddleware = store => dispattch => action => {
  if ( action.type !== types.REMOVE_PAGE ) {
    return dispattch( action )
  }
  const { payload } = action
  const pages = store.getState().pages.filter( p => +p.id !== +payload )
  const page = pages[0]
  dispattch( setActivePage( page ) )
  dispattch( setElements( page.items ) )
  return dispattch( action )
}

export default [
  updatePagesMiddleware,
  setPageMiddleware,
  onRemovePageMiddleware
]



// WEBPACK FOOTER //
// ./src/store/mniddlewares/pages.middleware.js